import styled, { css } from "styled-components";

export const StyledButtonWrapper = styled.div``;

export const StyledButtonGroup = styled.div`
    display: flex;
    align-items: center;
    ${({ direction }) => direction === "row" && css`
        flex-direction: row;
        margin: ${({ gutters }) => `0 -${gutters}px`};
        ${StyledButtonWrapper} { 
            margin: ${({ gutters }) => `0 ${gutters}px`};
        };
    `};
    ${({ direction }) => direction === "column" && css`
        flex-direction: column;
        margin: ${({ gutters }) => `-${gutters}px 0`};
        ${StyledButtonWrapper} {
            margin: ${({ gutters }) => `${gutters}px 0`};
        };
    `};
    ${({ customStyle }) => customStyle && customStyle};
`;